export default __webpack_public_path__ + "static/daRjUwVE-175a3ef608f45e97bb192111a76dc8d1.svg";